/* 
    自定义档案设置默认值组件
    created by:liyaoh
*/
import React, { Component } from "react";
import HotKeysModal from "Components/HotKeysModal";
import DefdocGridRef from "Components/Refers/DefdocGridRef";
import DefdocTreeRef from "Components/Refers/DefdocTreeRef";
import { langCheck } from "Pub/js/utils";

class CusDocDefaultValueModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultvalueObj: {}
        };
    }
    //传入的字符串进行分割，更新模态框内的默认取值对象
    componentWillReceiveProps(nextProps) {
        if (nextProps.modalVisibel !== true) {
            return;
        }
        let defaultvalueObj = {};
        const { defaultvalue, refname } = nextProps;
        //如果默认取值不为空，进行等号分割字符串
        if (defaultvalue) {
            const tmpDefaultvalueList = defaultvalue.split("=");
            defaultvalueObj = {
                display: tmpDefaultvalueList[0],
                value: tmpDefaultvalueList[1]
            };
        }
        this.setState({ defaultvalueObj });
    }

    //设置模态框隐藏
    showModalHidden = () => {
        this.props.setModalVisibel("customDocDefaultModalVisibel", false);
    };
    //更新dataval字段
    onOkDialog = () => {
        let { defaultvalueObj } = this.state;
        const display = defaultvalueObj.display;
        const value = defaultvalueObj.value;
        let defaultvalue = "";
        //原来参照ref和pk值
        if (display !== "" && value !== "") {
            defaultvalue = `${display}=${value}`;
        }
        this.props.handleSelectChange(defaultvalue, "defaultvalue");
        this.showModalHidden();
    };

    //根据isgrand渲染不同参照
    renderDocRefer = () => {
        const { isgrade, docPk, refname, json } = this.props;
        const { defaultvalueObj } = this.state;
        const referProps = {
            foolValue: defaultvalueObj,
            queryCondition: () => ({
                pk_defdoclist: docPk
            }),
            refName: refname,
            placeholder: refname,
            isMultiSelectedEnabled: this.props.isMultiSelectedEnabled,
            onChange: (ref, foolValue) => {
                this.setState({
                    defaultvalueObj: foolValue
                });
            }
        }
        
        //渲染树形参照
        if(isgrade === 'Y') {
            return <DefdocTreeRef fieldid="defdocTreeRef" {...referProps}/>;
        } else { //渲染列表参照
            return <DefdocGridRef fieldid="defdocGridRef" {...referProps}/>;
        }
    }
    render(){
        const { json } = this.props;
        return <HotKeysModal
                closable={false}
                title={langCheck("ZoneSetting-000227", "pages", json)} /* 国际化处理： 自定义档案默认值设置*/
                // mask={false}
                wrapClassName="zonesetting-defaultValueModal"
                visible={this.props.modalVisibel}
                okText={langCheck("ZoneSetting-000005", "pages", json)} /* 国际化处理： 确定*/
                cancelText={langCheck("ZoneSetting-000006", "pages", json)} /* 国际化处理： 取消*/
                onOk={this.onOkDialog}
                destroyOnClose={true}
                onCancel={this.showModalHidden}
                fieldid="cusDocDefault"
            >
                <div className="mdcontent">
                    {this.renderDocRefer()}
                </div>
            </HotKeysModal>
    }
}

export default CusDocDefaultValueModal;